import styled from 'styled-components';
import { up } from 'styled-breakpoints';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;

  ${up('md')} {
    padding: 24px 0;
  }
`;

export const AvatarWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;

  color: ${({ theme }) => theme.system.black};
  background-color: #fdf2e5;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 37px 45px;

  background-image: url(data:image/svg+xml;base64,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);

  ${up('md')} {
    width: 80px;
    height: 80px;
  }
`;

export const TextWrapper = styled.div`
  padding: 8px 0 8px 16px;

  ${up('md')} {
    padding: 12px 0 12px 24px;
  }
`;

export const Title = styled.p`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.3;

  ${up('md')} {
    font-size: 2.4rem;
  }
`;

export const Text = styled.span`
  font-size: 1.4rem;
  line-height: 1.3;
`;

export const LinkWrapper = styled.div`
  padding-top: 12px;

  ${up('md')} {
    padding-top: 24px;
  }

  ${Text} {
    font-size: 1.6rem;
    font-weight: 600;
  }

  a {
    display: flex;
    align-items: center;

    color: ${({ theme }) => theme.brand.blue};

    svg {
      margin-right: 4px;
    }

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;
